import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.css']
})
export class FaqComponent implements OnInit {
  @Input() settings: any
  @Input() data: any
  constructor() { }

  ngOnInit() {
    for (let i = 0; i < this.settings.FAQs.length; i++) {
      this.settings.FAQs[i].title =  this.settings.FAQs[i].title|| this.settings.FAQs[i].title;
      this.settings.FAQs[i].content =  this.settings.FAQs[i].content|| this.settings.FAQs[i].content;
    }
  }
 

}
